import { makeStyles } from "@material-ui/core/styles";
import ROUTES from "config/routing";

const useStyles = makeStyles((theme) => {
  // Detect if we're in iframe version
  const isPublicBuilder =
    typeof window !== "undefined" && window.location.pathname.includes(`${ROUTES.PUBLIC_FLYER_BUILDER.split("/")[1]}/`);

  return {
    page: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    drawer: {
      cursor:
        "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAWCAYAAADJqhx8AAAACXBIWXMAAAsSAAALEgHS3X78AAABVklEQVQ4jWP8//8/AyWA6f+v3z/+3rhnS64ZTP+/fPvPKCq0h1xDmP6//fDjS34rGwMDw7a/j5/7kGwAiPj34g3Dl4peHkYGxlX/3n3MItkAEPj/5RvD59xmToav33tIMYQJmYNsyN8HT0tINgDFkP//O/5cvlVHsgEwQ74UtjMz8nDVETIEqwHIhjAwMtbiMwSnAXBDCtpY/r16W/3vxZulJBsAA9/aZ7H9uXo75N/bD5vIMoABZsiF6+7ohhBtALIhf+8+PgITY8GlmEVfA6v4r22H2DizoqxBhjAry9pgNYCrMu0Xi7bqhf+fvlzHasrfvwwMjIyvsboApJlZTWE+k4RIBoOECEFvwQ1g5OFi4G4p+MPw/38rs6xkE0GdUAAORJBmnv7Kvwz//zez6KoRrRninScvPv+59/jP70s360DFG6kYRPwnVzPMAANyNf///58BANgjLIKd0D0WAAAAAElFTkSuQmCC') 2 0 , auto",
      position: "relative",
      width: "100%",
    },
    toolbar: {},
    settingPanel: {},
    sidebar: {
      zIndex: 10,
    },
    drawerWrapper: {
      display: "flex",
      width: "100%",
      height: "100%",
      alignItems: "stretch",
      flex: 1,
      position: "relative",
      overflow: "visible", // Ensure sidebar visibility
    },
    header: {
      background: "#FFFFFF",
      borderBottom: "solid 2px #ebebeb",
      boxShadow: "none",
      width: "100%",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
    headerWrapper: {
      background: "#F9F9FF",
      boxShadow: "0px 2px 14px rgba(39, 55, 84, 0.08)",
      width: "fit-content",
      minWidth: "100%",
      height: "auto",
      position: isPublicBuilder ? "fixed" : "relative",
      top: 0,
      zIndex: 3,
    },
    nextButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "148px",
      borderRadius: "16px",
      padding: "14px 30px",
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "20px",
      color: "#FFFFFF",
      backgroundColor: "#EE4360",
      transition: ".3s all",
      gap: "10px",
      cursor: "pointer",
    },
    nextButtonDisabled: {
      backgroundColor: "#AEAFC7",
      color: "#FFFFFF",
    },
    progress: {
      color: "white",
      marginRight: "4px",
    },
    exportDropdown: {
      position: "relative",
      display: "inline-block",
    },
    exportDropdownButton: {
      background: "transparent",
      border: "none",
      padding: "8px 12px",
      cursor: "pointer",
      fontSize: "14px",
      color: "#333",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      "&:hover": {
        backgroundColor: "#f5f5f5",
      },
    },
    exportDropdownContent: {
      position: "absolute",
      top: "100%",
      left: 0,
      backgroundColor: "#fff",
      border: "1px solid #ddd",
      borderRadius: "4px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      zIndex: 1000,
      minWidth: "150px",
      "& button": {
        color: "#000",
        display: "block",
        width: "100%",
        padding: "8px 12px",
        border: "none",
        background: "none",
        textAlign: "left",
        cursor: "pointer",
        fontSize: "14px",
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
        "&:first-child": {
          borderTopLeftRadius: "4px",
          borderTopRightRadius: "4px",
        },
        "&:last-child": {
          borderBottomLeftRadius: "4px",
          borderBottomRightRadius: "4px",
        },
      },
    },
    exportDropdownItem: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      color: "#000",
    },
  };
});

export default useStyles;
